module.exports = __webpack_public_path__ + "img/viva.eb21a49b.svg";